import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";

export default {
    name: "ManageMitigationModal",

    components: {
        customModal,
    },

    props: {
        mitigationItem: {
            type: Object,
            default: null,
        },
        kriId: {
            type: String,
            default: "",
        },
        riskId: {
            type: String,
            default: "",
        },
        ctqId: {
            type: String,
            default: "",
        },
        ctqFactor: {
            type: String,
            default: "",
        },
        fromPage: {
            type: String,
            default: ""
        }
    },

    emits: ["closeModal", "refreshData"],

    computed: {
        isEditMode() {
            return !!this.mitigationItem;
        },
        ctqFieldsLocked() {
            return this.fromPage === "riskListModal";
        },
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            errors: {
                riskDescription: "",
                mitigationStrategy: "",
            },
            values: {
                mitigationId: "",
                kriId: "",
                riskId: "",
                ctqId: "",
                ctqFactor: "",
                riskDescription: "",
                mitigationStrategy: "",
                actionOwner: "",
                targetCompletionDate: "",
                contingencyPlan: "",
                monitoringFrequency: "",
                evidenceOfImplementation: "",
                isActive: true,
            },
        };
    },

    mounted() {
        if (this.mitigationItem) {
            this.values = {
                mitigationId: this.mitigationItem.mitigationId || "",
                kriId: this.mitigationItem.kriId || this.kriId || "",
                riskId: this.mitigationItem.riskId || this.riskId || "",
                ctqId: this.mitigationItem.ctqId || this.ctqId || "",
                ctqFactor: this.mitigationItem.ctqFactor || this.ctqFactor || "",
                riskDescription: this.mitigationItem.riskDescription || "",
                mitigationStrategy: this.mitigationItem.mitigationStrategy || "",
                actionOwner: this.mitigationItem.actionOwner || "",
                targetCompletionDate: this.mitigationItem.targetCompletionDate ? this.formatDateForInput(this.mitigationItem.targetCompletionDate) : "",
                contingencyPlan: this.mitigationItem.contingencyPlan || "",
                monitoringFrequency: this.mitigationItem.monitoringFrequency || "",
                evidenceOfImplementation: this.mitigationItem.evidenceOfImplementation || "",
                isActive: this.mitigationItem.isActive !== undefined ? this.mitigationItem.isActive : true,
            };
        } else {
            // seed fields from props
            this.values.kriId = this.kriId;
            this.values.riskId = this.riskId;
            this.values.ctqId = this.ctqId;
            this.values.ctqFactor = this.ctqFactor;
        }
    },

    methods: {
        closeModal() {
            this.$emit("closeModal");
        },

        formatDateForInput(date) {
            if (!date) return "";
            try {
                return new Date(date).toISOString().split('T')[0];
            } catch (e) {
                return "";
            }
        },

        clear() {
            this.errors = { mitigationId: "", riskDescription: "", mitigationStrategy: "" };
            this.values = {
                mitigationId: this.isEditMode ? this.values.mitigationId : "",
                kriId: this.kriId,
                riskId: this.riskId,
                ctqId: this.ctqId,
                ctqFactor: this.ctqFactor,
                riskDescription: "",
                mitigationStrategy: "",
                monitoringFrequency: "",
                actionOwner: "",
                targetCompletionDate: "",
                contingencyPlan: "",
                evidenceOfImplementation: "",
                isActive: true,
            };
        },

        validate() {
            let valid = true;
            if (!this.values.mitigationId || !this.values.mitigationId.trim()) {
                this.errors.mitigationId = "Mitigation ID is required";
                valid = false;
            }
            if (!this.values.riskDescription || !this.values.riskDescription.trim()) {
                this.errors.riskDescription = "Risk Description is required";
                valid = false;
            }
            if (!this.values.mitigationStrategy || !this.values.mitigationStrategy.trim()) {
                this.errors.mitigationStrategy = "Mitigation Strategy is required";
                valid = false;
            }
            return valid;
        },

        async saveClicked() {
            if (!this.validate()) return;

            const idToken = store.getters.getIdToken;
            const studyId = store.getters.getStudyIs;

            const payload = {
                studyId,
                mitigationId: this.values.mitigationId,
                riskId: this.values.riskId,
                kriId: this.values.kriId,
                ctqId: this.values.ctqId,
                ctqFactor: this.values.ctqFactor,
                riskDescription: this.values.riskDescription,
                mitigationStrategy: this.values.mitigationStrategy,
                actionOwner: this.values.actionOwner,
                targetCompletionDate: this.values.targetCompletionDate,
                contingencyPlan: this.values.contingencyPlan,
                monitoringFrequency: this.values.monitoringFrequency,
                evidenceOfImplementation: this.values.evidenceOfImplementation,
                isActive: this.values.isActive,
            };

            try {
                const config = {
                    headers: {
                        Authorization: "Bearer " + idToken,
                        "Content-Type": "application/json",
                    },
                };

                if (this.isEditMode) {
                    await axios.put(
                        `${this.baseurl}/forms/ctq/updatemitigationplan?id=${this.mitigationItem.id}`,
                        payload,
                        config
                    );
                    alert("Mitigation updated successfully");
                } else {
                    await axios.post(
                        `${this.baseurl}/forms/ctq/createmitigationplan`,
                        payload,
                        config
                    );
                    alert("Mitigation added successfully");
                }

                this.$emit("refreshData");
                this.closeModal();
            } catch (error) {
                console.error(error);
                alert("Failed to save mitigation");
            }
        },
    },
};